import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import {
  getLength,
  getPrice,
  isEmptyObject,
  getTernaryValue,
  checkAllTrue,
  getAndCheck,
  isCateringDisposition,
  redirectToCateringPage,
  redirectToMenuPage,
  currentTimeOfStore,
  getAndCheckIfOneTrue,
  getCurrentLocation,
  getEmptyObjectforNull,
  jsontoObjects,
} from 'common/utilities/utils';
import QuantityModifierAddToCart from 'molecules/QuantityModifierAddToCart/QuantityModifierAddToCart';
import { CART_PAGE_CONSTANTS } from 'organisms/CartPage/Constants/CartPageConstants';
import { MENU_PDP_PAGE_CONSTANTS } from '../Constants/MenuPDPPageConstants';
import { LOCAL_STORAGE_KEYS, priceFixed_value, EVERYDAY, WEEKDAYNAME } from 'common/constants/SharedConstants';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { getAddToOrderConfirmButtonState } from 'molecules/ModifierCard/AU/Container/ModifierCardComponent';
import { AnchorWithLink } from 'atoms/Anchor';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { toast } from 'react-toastify';
import find from 'lodash/find';
import { getFormattedTimeWithTimeZone } from 'common/utilities/dayJsUtils';
import ImageComponent from 'atoms/Image/Container/ImageComponent';
import { RecommendedItemAnalytic } from 'common/utilities/analyticsUtils';
import { onSaveProductCommon } from 'organisms/ProductListingModalOptions/AU/Presentation/ModifierCard';
import { getComboAndRecommendationDataSopac, resetPayload } from 'organisms/MenuPDPPage/AU/Presentation/MenusPdpItem';
import isNumber from 'lodash/isNumber';

export const computePrice = (price, currencyConversionFactor, pdpPromoPage, id, storeTimeZone) => {
  let getprice;
  if (pdpPromoPage) {
    const promoDetails = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.VIEW_PRODUCT));
    const availability = [
      computeSurgePrice(promoDetails?.priceDetails?.find(it => it?.id === id)?.availability, storeTimeZone),
    ];
    const promoPrice = availability?.[0]?.promoPrice < availability?.[0]?.price ? availability?.[0]?.promoPrice : 0;
    const updatedPrice = promoPrice
      ? {
          ...availability?.[0],
          price: promoPrice,
        }
      : price;
    return getPrice(updatedPrice, currencyConversionFactor, storeTimeZone) || 0;
  }
  if (isEmptyObject(price)) {
    getprice = getPrice(price, currencyConversionFactor, storeTimeZone) || 0;
  }
  return getprice;
};
export const isCurrentTimeBetweenStartAndEndTime = (storeCurrentTime, startTimer, endTimer, price, higherPrice) => {
  if (storeCurrentTime >= startTimer && storeCurrentTime <= endTimer && price > higherPrice) {
    return true;
  }
  return false;
};

export const computeSurgePrice = (availability = [], timeZone = '') => {
  let higherPrice = 0;
  if (availability.length > 1) {
    const storeCurrentTime = currentTimeOfStore(timeZone);
    const currentDay = timeZone && getFormattedTimeWithTimeZone(timeZone, WEEKDAYNAME);
    availability.forEach(item => {
      const {
        price = 0,
        availableHours = {},
        dayOfWeek: { day = '' },
      } = item;
      const { startTime = {}, endTime = {} } = availableHours;
      const startTimer = parseInt(startTime.time, 10);
      const endTimer = parseInt(endTime.time, 10);
      const isCurrentTimeValid = isCurrentTimeBetweenStartAndEndTime(
        storeCurrentTime,
        startTimer,
        endTimer,
        price,
        higherPrice,
      );
      if (day === EVERYDAY) {
        if (
          (startTimer < endTimer && isCurrentTimeValid) ||
          (startTimer > endTimer &&
            (storeCurrentTime >= startTimer || storeCurrentTime <= endTimer) &&
            price > higherPrice)
        ) {
          higherPrice = price;
        }
      } else if (day === currentDay && isCurrentTimeValid) {
        higherPrice = price;
      }
    });
    return currentDay && find(availability, [MENU_PDP_PAGE_CONSTANTS.DAY_OF_WEEK, { day: currentDay?.toUpperCase() }]);
  }
  return availability[0];
};

/**
 *
 * @param {*} pdpData
 * @param {*} prodQuantity
 * @param {*} currencyConversionFactor
 * @returns initial payload data
 */
export const createPDPPayload = (
  pdpData,
  prodQuantity,
  currencyConversionFactor,
  pdpPromoPage,
  storeTimeZone,
  pdpDataForUpdateFoodLine,
  cartData,
) => {
  const { id, name, modgrps, availability = [] } = getEmptyObjectforNull(JSON.parse(JSON.stringify(pdpData)));
  const finalAvailability = storeTimeZone ? computeSurgePrice(availability, storeTimeZone) : availability[0];
  let basePrice =
    pdpDataForUpdateFoodLine?.foodLineId && checkSelectedProduct(pdpDataForUpdateFoodLine?.foodLineId, cartData, id)
      ? takeCartBasePrice(pdpDataForUpdateFoodLine?.foodLineId, cartData)
      : Math.round(
          computePrice(finalAvailability, currencyConversionFactor, pdpPromoPage, id, storeTimeZone) *
            currencyConversionFactor,
        );
  return {
    id,
    quantity: prodQuantity ?? 0,
    name,
    basePrice,
    newBasePrice: basePrice,
    unitPrice: prodQuantity ? basePrice * prodQuantity : 0,
    modGrps: getAllModGData(modgrps, currencyConversionFactor, id),
  };
};
const checkSelectedProduct = (foodLineId, cartData, productId) => {
  let itemMatched = cartData?.foodLines?.find(({ id }) => id === foodLineId);
  return itemMatched?.item?.id === productId ? true : false;
};

const takeCartBasePrice = (foodLineId, cartData) => {
  let itemMatched = cartData?.foodLines?.find(({ id }) => id === foodLineId);
  if (itemMatched) {
    return itemMatched?.unitPrice;
  }
};
export const updateModGrps = (foodLineId, cartData, modgrps) => {
  let itemMatched = cartData?.foodLines?.find(({ id }) => id === foodLineId);
  let cartModgrps = itemMatched?.item?.modGrps;
  modgrps?.forEach((modG, j) => {
    modG?.modifiers?.forEach((modF, i) => {
      let cartModiFMatched = getModiFItem(cartModgrps, modG.id, modF.id);
      if (cartModiFMatched?.length > 0) {
        modF = { ...modF, ...cartModiFMatched?.[0] };
        modF.mdmId = modF.id;
        modgrps[j].modifiers[i] = modF;

        // updating L3 modifiers
        modF?.modgrps?.forEach((l2ModG, g) => {
          l2ModG?.modifiers?.forEach((l3ModF, k) => {
            let L3cartModiFMatched = cartModiFMatched[0].modGrps[g]?.modifiers?.filter(({ id }) => id === l3ModF.id);
            if (L3cartModiFMatched?.length > 0) {
              l3ModF = { ...l3ModF, ...L3cartModiFMatched?.[0] };
              l3ModF.mdmId = l3ModF.id;
              l3ModF.isEditConfirmed = l3ModF?.custom;
              if (l3ModF?.custom) {
                modF.isEditConfirmed = true;
              }
              modgrps[j].modifiers[i].modgrps[g].modifiers[k] = l3ModF;
            }
          });
        });
      }
    });
    let isAddedFound = modG?.modifiers?.some(ele => ele.isAdded);
    let isMultiSelection = checkMultiselection(modG);
    modG?.modifiers?.forEach(resetModF => {
      resetModF.isInitialDefault = setInitialDefault(resetModF);
      if (isAddedFound) {
        resetModF['isDefault'] = resetModF?.isAdded ? true : false;
      }
      updateMultiselection(isMultiSelection, resetModF);
      // updating L3 modifiers
      resetModF?.modgrps?.forEach((l2ModG, g) => {
        let l3IsAddedFound = l2ModG?.modifiers?.some(ele => ele.isAdded);
        let L3IsMultiSelection = checkMultiselection(l2ModG);
        l2ModG?.modifiers?.forEach(l3ResetModF => {
          l3ResetModF.isInitialDefault = setInitialDefault(l3ResetModF);
          if (l3IsAddedFound) {
            l3ResetModF['isDefault'] = l3ResetModF?.isAdded ? true : false;
          }
          updateMultiselection(L3IsMultiSelection, l3ResetModF);
        });
      });
    });
  });
  return modgrps;
};
const updateMultiselection = (L3IsMultiSelection, resetModF) => {
  if (L3IsMultiSelection && resetModF?.custom) {
    resetModF.isDefault = false;
    resetModF.quantity = 0;
  }
};
const checkMultiselection = resetModF => {
  let isDefaultItem = resetModF?.modifiers?.filter(ele => ele?.isDefault);
  return isDefaultItem?.length > 1 ? true : false;
};
const setInitialDefault = resetModF => {
  return resetModF?.isInitialDefault ? resetModF.isInitialDefault : resetModF.isDefault;
};
const getModiFItem = (cartModgrps, parentId, childId) => {
  let cartModGrpsMatched = cartModgrps?.filter(({ id }) => id === parentId);
  return cartModGrpsMatched?.[0]?.modifiers?.filter(({ id }) => id === childId);
};

const getAllModGData = (modgrps, currencyConversionFactor, parentId) => {
  let allModData = {};
  modgrps?.forEach(
    (modG, index) =>
      (allModData[modG.id] = {
        id: modG.id,
        name: modG.name,
        parentId,
        modifiers: getAllModFData(
          modG.modifiers,
          currencyConversionFactor,
          `${parentId}${MENU_PDP_PAGE_CONSTANTS.HASH_SYMBOL}${modG.id}`,
        ),
        orderIndex: index,
        min: modG.min,
      }),
  );
  return allModData;
};
const setQuantity = modF => {
  if (modF?.quantity) {
    return modF?.quantity;
  }
  return modF?.isDefault ? modF?.defaultQuantity : 0;
};
const getAllModFData = (modifiers, currencyConversionFactor, parentId) => {
  let allModData = {};
  modifiers.forEach(modF => {
    let price = +Math.round(getPrice(modF.availability[0], currencyConversionFactor) * currencyConversionFactor);
    allModData[modF.id] = {
      id: modF.id,
      parentId,
      name: modF.name,
      dname: modF.dname,
      quantity: setQuantity(modF),
      isSelected: modF.isDefault,
      modGrps: getLength(modF.modgrps)
        ? getAllModGData(
            modF.modgrps,
            currencyConversionFactor,
            `${parentId}${MENU_PDP_PAGE_CONSTANTS.HASH_SYMBOL}${modF.id}`,
          )
        : {},
      basePrice: price,
      unitPrice: modF.isDefault ? modF.defaultQuantity * price : 0,
      newQuantity: null,
      newUnitPrice: null,
      newSelectedFlag: null,
      isDefault: !modF.isAdded ? modF.isDefault : '',
      defaultQuantity: modF.defaultQuantity,
      isEditConfirmed: modF.isEditConfirmed ? modF.isEditConfirmed : false,
      isExcluded: modF.isExcluded,
      isInitialDefault: modF?.isInitialDefault,
    };
  });
  return allModData;
};

/**
 *
 * @param {*} payloadData
 * @returns payload data in API format
 */
export const getFinalPayload = payloadData => {
  let { id, quantity } = payloadData;
  return { id, quantity, modGrps: filterModGData(payloadData.modGrps) };
};

const filterModGData = modGrps => {
  return Object.values(modGrps)
    .filter(modG => Object.keys(modG.modifiers).length > 0)
    .map(modG => {
      let { id, name, orderIndex } = modG;
      return { id, name, modifiers: filterModFData(modG.modifiers), orderIndex };
    })
    .sort((a, b) => +a.orderIndex - +b.orderIndex);
};

const filterModFData = modifiers => {
  return Object.values(modifiers)
    .filter(modF => modF.quantity > 0 && !modF.isExcluded)
    .map(modF => {
      let { id, name, quantity, modGrps } = modF;
      return { id, name, quantity, modGrps: Object.keys(modGrps).length > 0 ? filterModGData(modGrps) : [] };
    });
};
export const updateItemQuantity = (payloadData, prodQuantity) => {
  return {
    ...payloadData,
    quantity: prodQuantity ?? 0,
    unitPrice: prodQuantity ? payloadData.basePrice * prodQuantity : 0,
  };
};

export const checkForQuantityLimit = (prodQuantity, pdpPromoPage, item) => {
  const increasedQty = prodQuantity + 1;
  const promoDetails = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.VIEW_PRODUCT));
  const maxQuantity = item?.maxQuantity
    ? +item?.maxQuantity
    : +promoDetails?.promoParams?.find(it => it?.itemId === item?.id)?.maxQuantity;
  if (increasedQty === maxQuantity && pdpPromoPage) {
    return toast(
      <div data-testid='validate-toast' className='img-text-container'>
        <div className='image'>
          <ImageComponent srcFile={IMAGE_PATH.ErrorImage} />
        </div>
        <span className='text'>{translateWithI18Next(TRANSLATE_MAPPING_KEY.MAX_ORDER_PROMO)}</span>
      </div>,
      {
        bodyClassName: 'pdp-promo-toast',
        className: 'pdp-promo-toast-container err-toast',
        hideProgressBar: true,
        position: toast.POSITION.BOTTOM_CENTER,
        closeButton: false,
        autoClose: true,
      },
    );
  }
};

export const getMaxItemCountPerLineItem = (pdpPromoPage, promoDetails, itemId, maxItemCountPerLineItem) => {
  if (pdpPromoPage) {
    const maxQuantity = +promoDetails?.promoParams?.find(it => it?.itemId === itemId)?.maxQuantity;
    return maxQuantity ? maxQuantity : maxItemCountPerLineItem;
  } else {
    return maxItemCountPerLineItem;
  }
};

export const getItemQuantity = (pdpPromoPage, promoDetails, itemId, defaultQuantity) => {
  if (pdpPromoPage) {
    const minQuantity = +promoDetails?.promoParams?.find(it => it?.itemId === itemId)?.quantity;
    return minQuantity ? minQuantity : defaultQuantity;
  } else {
    return defaultQuantity;
  }
};

/**
 *
 * @param {*} data
 * @param {*} objpath
 * @returns modifier by path
 */
export const getModifierByPath = (data, objpath) => {
  const idsArr = objpath.includes(MENU_PDP_PAGE_CONSTANTS.HASH_SYMBOL)
    ? objpath.split(MENU_PDP_PAGE_CONSTANTS.HASH_SYMBOL)
    : [objpath];
  if (getLength(idsArr) && data?.length !== 0 && getLength(Object.keys(data?.modGrps))) {
    let tempData = data;
    idsArr.forEach((arr, index) => {
      if (index % 2 === 0) {
        tempData = tempData?.modGrps[arr];
      } else {
        tempData = tempData?.modifiers[arr];
      }
    });
    return tempData;
  } else {
    return false;
  }
};
/**
 *
 * @param {*} payloadData
 * @param {*} objpath
 * @returns modifier item quantity or intermediate quantity in L3
 */
export const getSavedQuantity = (payloadData, objpath) => {
  let modifierData = getModifierByPath(payloadData, objpath);
  return isEmptyObject(modifierData)
    ? (modifierData.newQuantity === null && modifierData.quantity) || modifierData.newQuantity
    : null;
};

/**
 *
 * @param {*} payloadData
 * @param {*} objpath
 * @returns modifier item selectedFlag or intermediate selectedFlag in L3
 */
export const getSavedIsDefault = (payloadData, objpath) => {
  let modifierData = getModifierByPath(payloadData, objpath);
  if (isEmptyObject(modifierData)) {
    return modifierData.newSelectedFlag === null ? modifierData.isSelected : modifierData.newSelectedFlag;
  } else {
    return null;
  }
};

/**
 *
 * @param {*} payloadData
 * @param {*} objpath
 * @returns modifier item editFlag
 */
export const getSavedIsEdit = (payloadData, objpath) => {
  let modifierData = getModifierByPath(payloadData, objpath);
  return isEmptyObject(modifierData) ? modifierData.isEditConfirmed : null;
};

/**
 *
 * @param {*} payloadData
 * @param {*} objpath
 * @returns modifier item basePrice
 */
export const getSavedPrice = (payloadData, objpath, selectedQuantity) => {
  let modifierData = getModifierByPath(payloadData, objpath);
  return isEmptyObject(modifierData) ? getModifierPrice(modifierData, selectedQuantity) : 0;
};

const getModifierPrice = (modifierData, selectedQuantity) => {
  let flatData = getAllModFflatResp(modifierData.modGrps, [modifierData]);
  let initialBasePrice = 0;
  if (flatData.length === 0) {
    return initialBasePrice;
  }
  return flatData
    .filter(item => {
      let isSelectedFlag = item?.id === modifierData?.id ? true : item?.isSelected;
      return isSelectedFlag === true;
    })
    .reduce((prevval, currval) => {
      let qty = currval?.id === modifierData?.id ? selectedQuantity : modifierData?.quantity;
      return prevval + currval?.basePrice * qty;
    }, initialBasePrice);
};

const getAllModFflatResp = (modGrps, arr) => {
  let allModifierData = [];
  if (isEmptyObject(modGrps)) {
    allModifierData = Object.values(modGrps)
      .map(item => Object.values(item.modifiers))
      .reduce(function (pre, cur) {
        return pre.concat(cur);
      });
    allModifierData.forEach(modifier => {
      arr.push(modifier);
      return isEmptyObject(modifier.modGrps) ? getAllModFflatResp(modifier.modGrps, arr) : getAllModFflatResp({}, arr);
    });
  }
  return arr;
};

/**
 *
 * @param {*} payloadData
 * @param {*} objpath
 * @param {*} itemCount
 * @param {*} keyObj
 * @returns updated modifier data based on dynamic key
 */
const getUpdatedData = (payloadData, objpath, itemCount, keyObj) => {
  const idsArr = objpath.split(MENU_PDP_PAGE_CONSTANTS.HASH_SYMBOL);
  const { quantityKey, unitPriceKey, isSelectedKey } = keyObj;
  const modifierData = getModifierByPath(payloadData, objpath);
  if (getLength(idsArr) && payloadData && getLength(Object.keys(payloadData.modGrps))) {
    let tempData = null;
    // eslint-disable-next-line default-case
    switch (idsArr.length) {
      case 2:
        tempData = payloadData.modGrps[idsArr[0]].modifiers[idsArr[1]];
        break;
      case 4:
        tempData = payloadData.modGrps[idsArr[0]].modifiers[idsArr[1]].modGrps[idsArr[2]].modifiers[idsArr[3]];
        break;
    }
    tempData[quantityKey] = itemCount;
    tempData[unitPriceKey] = itemCount ? itemCount * modifierData.basePrice : modifierData.basePrice;
    tempData[isSelectedKey] = itemCount ? true : false;
  }
  return payloadData;
};

/**
 *
 * @param {*} payloadData
 * @param {*} objpath
 * @param {*} itemCount
 * @returns updated new Props for combo L3
 */
export const updateModifierNewProps = (payloadData, objpath, itemCount) => {
  let keyObj = { quantityKey: 'newQuantity', unitPriceKey: 'newUnitPrice', isSelectedKey: 'newSelectedFlag' };
  return getUpdatedData(payloadData, objpath, itemCount, keyObj);
};

/**
 *
 * @param {*} payloadData
 * @param {*} objpath
 * @param {*} itemCount
 * @returns updated actual props for L2
 */
export const updateModifier = (payloadData, objpath, itemCount) => {
  let keyObj = { quantityKey: 'quantity', unitPriceKey: 'unitPrice', isSelectedKey: 'isSelected' };
  return getUpdatedData(payloadData, objpath, itemCount, keyObj);
};

/**
 *
 * @param {*} payloadData
 * @param {*} objpath
 * @returns updated actual props from new props on confirm
 */
export const updateModifierFromNewProps = (payloadData, objpath) => {
  const arr = objpath.split(MENU_PDP_PAGE_CONSTANTS.HASH_SYMBOL);
  const modifierData = payloadData.modGrps[arr[0]].modifiers[arr[1]];
  let editFlag = false;
  const data = Object.values(modifierData.modGrps)
    .map(item => Object.values(item.modifiers))
    .reduce(function (pre, cur) {
      return pre.concat(cur);
    });
  data.forEach(item => {
    let itemDefaultQty = getTernaryValue(item.isInitialDefault, item.defaultQuantity, 0);
    if (
      checkAllTrue([
        item.newQuantity !== null,
        item.newQuantity !== item.quantity,
        item.newQuantity !== itemDefaultQty,
      ]) ||
      getAndCheck(item.newQuantity == null, item.quantity !== itemDefaultQty) ||
      checkAllTrue([item.newQuantity !== null, item.newQuantity === item.quantity, item.newQuantity !== itemDefaultQty])
    ) {
      editFlag = true;
    }
    if (
      item.newQuantity !== null &&
      item.newUnitPrice !== null &&
      item.newSelectedFlag !== null &&
      item.newQuantity !== item.quantity
    ) {
      item.quantity = item.newQuantity;
      item.unitPrice = item.newUnitPrice;
      item.isSelected = item.newSelectedFlag;
    }
  });
  modifierData.isEditConfirmed = editFlag;
  payloadData.basePrice = payloadData.newBasePrice;
  payloadData.unitPrice = payloadData.newBasePrice * payloadData.quantity;
  return payloadData;
};

/**
 *
 * @param {*} payloadData
 * @param {*} objpath
 * @returns reset new props on cancel
 */
export const resetModifierNewProps = (payloadData, objpath) => {
  const arr = objpath.split(MENU_PDP_PAGE_CONSTANTS.HASH_SYMBOL);
  const modifierData = payloadData.modGrps[arr[0]].modifiers[arr[1]];
  const prevData = Object.values(modifierData.modGrps)
    .map(item => Object.values(item.modifiers))
    .reduce(function (pre, cur) {
      return pre.concat(cur);
    });
  prevData.forEach(item => {
    if (item.newQuantity !== null && item.newUnitPrice !== null && item.newSelectedFlag !== null) {
      item.newQuantity = item.newUnitPrice = item.newSelectedFlag = null;
    }
  });
  payloadData.newBasePrice = payloadData.basePrice;
  return payloadData;
};

/**
 *
 * @param {*} payloadData
 * @param {*} objpath
 * @returns revert customization on modifier uncheck
 */
export const revertCustomizationOnUncheck = (payloadData, objpath) => {
  const objArr = objpath.split(MENU_PDP_PAGE_CONSTANTS.HASH_SYMBOL);
  const modifierData = payloadData.modGrps[objArr[0]].modifiers[objArr[1]];
  if (getLength(Object.values(modifierData.modGrps))) {
    const data = Object.values(modifierData.modGrps)
      .map(item => Object.values(item.modifiers))
      .reduce(function (pre, cur) {
        return pre.concat(cur);
      });
    data.forEach(item => {
      item.isSelected = item.isDefault;
      item.quantity = item.isDefault ? item.defaultQuantity : 0;
      item.unitPrice = item.isDefault ? item.defaultQuantity * item.basePrice : 0;
    });
    modifierData.isEditConfirmed = false;
  }
  return payloadData;
};

/**
 *
 * @param {*} payloadData
 * @param {*} objpath
 * @returns flag based on user activities in L3
 */
export const checkIfAnyModifierChanged = (payloadData, objpath) => {
  const arr = objpath.split(MENU_PDP_PAGE_CONSTANTS.HASH_SYMBOL);
  const modifierData = payloadData.modGrps[arr[0]].modifiers[arr[1]];
  const data = Object.values(modifierData.modGrps)
    .map(item => Object.values(item.modifiers))
    .reduce(function (pre, cur) {
      return pre.concat(cur);
    });
  return data.some(ele => ele.newQuantity !== null && ele.newQuantity !== ele.quantity);
};

/**
 *
 * @param {*} modgrpId
 * @param {*} payloadData
 * @returns flag based on user activities in L3
 */
export const checkIfAnyModifierEdited = (modgrpId, payloadData) => {
  const modiGrpData = payloadData?.modGrps?.[modgrpId];
  if (isEmptyObject(modiGrpData)) {
    const data = Object.values(modiGrpData.modifiers);
    return data.some(modg => (modg.isInitialDefault && !modg.isSelected) || (modg.isSelected && modg.isEditConfirmed));
  } else {
    return false;
  }
};

/**
 *
 * @param {*} payloadData
 * @param {*} param1
 * @param {*} isModal
 * @returns updated price on selection modifier without modgroups
 */
export const updateItemPrice = (payloadData, { price, flag }, isModal) => {
  const { BASEPRICE, NEWBASEPRICE } = MENU_PDP_PAGE_CONSTANTS;
  const { QUANTITY_ACTION } = CART_PAGE_CONSTANTS;
  let key = isModal ? NEWBASEPRICE : BASEPRICE;
  let prevPrice = payloadData[key];
  let currentPrice = flag === QUANTITY_ACTION.Increase ? prevPrice + price : prevPrice - price;
  let data = {
    ...payloadData,
    [key]: currentPrice,
    unitPrice: key === BASEPRICE ? payloadData.quantity * currentPrice : payloadData.unitPrice,
  };
  if (key === BASEPRICE) {
    data.newBasePrice = currentPrice;
  }
  return data;
};

/**Presentation logic */
export const getModGroupObjPath = (isModal, modgrpId, sopacPDPCustomization) => {
  const { showCustomizationModId = '', showCustomizationModGrpId = '' } = sopacPDPCustomization;
  if (isModal) {
    return `${showCustomizationModGrpId}${MENU_PDP_PAGE_CONSTANTS.HASH_SYMBOL}${showCustomizationModId}${MENU_PDP_PAGE_CONSTANTS.HASH_SYMBOL}${modgrpId}`;
  } else {
    return `${modgrpId}`;
  }
};
const filterquantity = payloadModifier =>
  payloadModifier.filter(element => {
    let qty = element?.newQuantity === null ? element?.quantity : element?.newQuantity;
    return qty >= 1;
  });
export const getSubHeaderData = (
  pdpPayloadData,
  ObjPath,
  currencyConversionFactor,
  renderSuffixonUnselect,
  currencySymbol,
) => {
  const { NO } = TRANSLATE_MAPPING_KEY;
  let payLoadData = getModifierByPath(pdpPayloadData, ObjPath);
  if (payLoadData && getLength(Object.keys(payLoadData))) {
    const payloadModifier = Object.values(payLoadData?.modifiers);
    let defaultData = renderSuffixonUnselect ? payloadModifier : filterquantity(payloadModifier);
    let totalNoOfModifiersArr = [];
    return defaultData.map(({ name, quantity, newQuantity, basePrice, newUnitPrice, isExcluded }, index) => {
      let qtyToShow = newQuantity !== null ? newQuantity : quantity;
      let unitPrice = basePrice * qtyToShow;
      let unitPriceToShow = newUnitPrice !== null ? newUnitPrice : unitPrice;
      qtyToShow > 0 ? totalNoOfModifiersArr?.push(index) : totalNoOfModifiersArr.filter(item => item !== index);
      return (
        <span>
          {totalNoOfModifiersArr?.length > 1 && !!qtyToShow && <span>,</span>}{' '}
          {isExcluded && <span>{`${translateWithI18Next(NO)} ${name} (-)`}</span>}
          {!isExcluded && (
            <>
              {qtyToShow > 1 && <span> {qtyToShow}x </span>}
              {qtyToShow > 0 && name}
              {unitPriceToShow !== 0 && qtyToShow > 0 && (
                <span>
                  {' '}
                  (+ {currencySymbol + (unitPriceToShow / currencyConversionFactor).toFixed(priceFixed_value)})
                </span>
              )}
              {qtyToShow === 0 && !!quantity && renderSuffixonUnselect && (
                <span>{`${translateWithI18Next(NO)} ${name} (-)`}</span>
              )}
            </>
          )}
        </span>
      );
    });
  }
};

export const getSubHeaderDataL2 = (pdpPayloadData, ObjPath, currencyConversionFactor, currencySymbol) => {
  const { INEXTRAS } = MENU_PDP_PAGE_CONSTANTS;
  let modifierDataL2 = getModifierByPath(pdpPayloadData, ObjPath);
  if (modifierDataL2 && isEmptyObject(modifierDataL2) && isEmptyObject(modifierDataL2?.modGrps)) {
    let unitPriceToShow = Object.values(modifierDataL2?.modGrps)
      .map(item => Object.values(item.modifiers))
      .reduce(function (pre, cur) {
        return pre.concat(cur);
      })
      .filter(element => element.quantity > 0)
      .reduce(function (prev, curr) {
        return prev + curr?.basePrice * curr?.quantity;
      }, 0);
    return unitPriceToShow !== 0
      ? ` (+ ${currencySymbol}${(unitPriceToShow / currencyConversionFactor).toFixed(
          priceFixed_value,
        )} ${translateWithI18Next(INEXTRAS)}) `
      : false;
  }
  return (
    modifierDataL2.basePrice !== 0 &&
    `(+ ${currencySymbol}${((modifierDataL2.basePrice * modifierDataL2.quantity) / currencyConversionFactor).toFixed(
      priceFixed_value,
    )}) `
  );
};

export const getAddToCartTemplate = pdpCardObject => {
  return <QuantityModifierAddToCart {...pdpCardObject} />;
};

export const updateItemPriceForCheckbox = (
  pdpPayloadData,
  forModal,
  modgrps,
  getPayloadUpdated,
  modifierPrice,
  isL3Custom,
  getUpdatedPrice,
  userOrderState,
  flag,
) => {
  const { QUANTITY_ACTION } = CART_PAGE_CONSTANTS;
  let updatedPrice = userOrderState?.sopacPDPCustomization?.updatedPrice;
  if (isEmptyObject(pdpPayloadData) && !forModal) {
    if (!getLength(modgrps)) {
      getPayloadUpdated = updateItemPrice(pdpPayloadData, { price: modifierPrice, flag }, isL3Custom);
    }
    if (isL3Custom) {
      getUpdatedPrice = flag === QUANTITY_ACTION.Decrease ? updatedPrice - modifierPrice : updatedPrice + modifierPrice;
    }
  }
  return { getPayloadUpdated, getUpdatedPrice };
};

const getInputReturn = (valueToDisplay, valueToCount) => {
  return isNumber(valueToCount) ? { valueToDisplay, valueToCount } : { valueToDisplay, valueToCount: valueToDisplay };
};

export const validateFreeInputField = (event, validationFields) => {
  const {
    modgrpMax,
    modgrpMin,
    modifierMax,
    modifierMin,
    modgrpCount,
    itemCount,
    SET_PDP_BUTTON_DISABLED,
    userOrderStateDispatch,
    userOrderState,
    modgrpId,
    pdpCateringItemQuantityLimit,
  } = validationFields;
  let eventVal = Number(event.target.value);
  let value = event.target.value;
  if (!isNaN(eventVal) && isNumber(eventVal)) {
    if (getAndCheck(value === '', modgrpMax)) {
      getAddToOrderConfirmButtonState(
        modgrpCount - itemCount,
        modgrpMin,
        SET_PDP_BUTTON_DISABLED,
        userOrderStateDispatch,
        userOrderState,
        modgrpId,
      );
      return getInputReturn(value, modifierMin);
    } else if (value === '') {
      return getInputReturn(value);
    } //to check backspace
    else {
      value = +value;
    } //to convert into number
    if (value > pdpCateringItemQuantityLimit) {
      return getInputReturn(false);
    }
    //only for modifier quantity validation
    if (modgrpMax !== undefined) {
      let updatedModgrpCount = modgrpCount - itemCount + value;
      let availableModgQuantity = modgrpMax - updatedModgrpCount;
      let availableModfQuantity = modifierMax - value;
      if (availableModgQuantity < 0) {
        let remainingCount = modgrpMax - modgrpCount + itemCount;
        getAddToOrderConfirmButtonState(
          updatedModgrpCount,
          modgrpMin,
          SET_PDP_BUTTON_DISABLED,
          userOrderStateDispatch,
          userOrderState,
          modgrpId,
        );
        let result = getTernaryValue(remainingCount <= modifierMax, remainingCount, modifierMax);
        return getInputReturn(result);
      }
      if (availableModgQuantity >= 0) {
        getAddToOrderConfirmButtonState(
          updatedModgrpCount,
          modgrpMin,
          SET_PDP_BUTTON_DISABLED,
          userOrderStateDispatch,
          userOrderState,
          modgrpId,
        );
        if (availableModfQuantity >= 0) {
          return getInputReturn(value);
        } else {
          return getInputReturn(modifierMax);
        }
      }
    }
    return getInputReturn(value);
  } else {
    return getInputReturn(false);
  }
};

export const getQtySelectorClassName = dispositionType => {
  return getTernaryValue(isCateringDisposition(dispositionType), '', 'retail-item-qty');
};
export const breadcrumbtemplate = displayBreadcrumbPDP => {
  return getLength(displayBreadcrumbPDP) ? (
    displayBreadcrumbPDP?.map((link, idx) => {
      let href = getTernaryValue(idx === 0, `/${link.url}`, `/${displayBreadcrumbPDP[0].url}/${link.url}`);
      return (
        <>
          <AnchorWithLink className='pdp-anchor-link' href={href}>
            {link.text}
          </AnchorWithLink>
          <span>{getTernaryValue(idx === displayBreadcrumbPDP.length - 1, '', ' > ')}</span>
        </>
      );
    })
  ) : (
    <></>
  );
};

export const checkExcludedModGItem = (modgrpId, payloadData) => {
  let selectedItemExcluded = false;
  const modiGrpData = payloadData?.modGrps?.[modgrpId];
  if (isEmptyObject(modiGrpData)) {
    const data = Object.values(modiGrpData?.modifiers);
    selectedItemExcluded =
      modiGrpData?.min > 0
        ? data.some(ele => ele.isSelected && ele?.isExcluded) || data.every(ele => !ele.isSelected)
        : false;
  }
  return selectedItemExcluded;
};
export const checkExcludedItem = pdpPayloadData => {
  let itemFound = false;
  let modGrps = pdpPayloadData?.modGrps;
  for (let g in modGrps) {
    itemFound = checkExcludedModGItem(modGrps[g]?.id, pdpPayloadData);
    if (itemFound) {
      return true;
    }
    let modifiers = modGrps[g]?.modifiers;
    for (let m in modifiers) {
      if (modifiers?.[m]?.isSelected) {
        itemFound = checkExcludedItem(modifiers?.[m]);
        if (itemFound) {
          return true;
        }
      }
    }
  }
  return itemFound;
};

export const redirectToPage = (isFromCatering, history) => {
  if (isFromCatering) {
    redirectToCateringPage({ history });
  } else {
    redirectToMenuPage({ history });
  }
};

export const RecommendedAnalyticHandler = (
  isItemAdded,
  analyticObjectData,
  userType,
  itemsList,
  currency,
  couponCode,
) => {
  if (analyticObjectData?.id && isItemAdded) {
    RecommendedItemAnalytic(userType, itemsList, analyticObjectData?.totalAmount, currency, couponCode);
  }
};

export const onSaveProductHandler = params => {
  const {
    modgrpMax,
    selectedProduct,
    modgrpMin,
    name,
    size,
    location,
    setInitialRender,
    savedModifierHandler,
    setSelectedProduct,
    cardData,
    savedModifiers,
    userOrderState,
    userOrderStateDispatch,
    modGrpName,
    pdpPayloadData,
    objPath,
    isModal,
  } = params;
  if (getAndCheckIfOneTrue(getAndCheck(modgrpMax === 1, !selectedProduct), modgrpMin === 0)) {
    let analyticsObjectData = { name, size };
    let currLocationInfo = getCurrentLocation(location.pathname);
    let analyticspayloadData = { analyticsObjectData, currLocationInfo };
    setInitialRender(false);
    onSaveProductCommon(
      analyticsObjectData,
      currLocationInfo,
      analyticspayloadData,
      modgrpMin,
      modgrpMax,
      selectedProduct,
      savedModifierHandler,
      setSelectedProduct,
      cardData,
      savedModifiers,
      userOrderState,
      userOrderStateDispatch,
      modGrpName,
      pdpPayloadData,
      objPath,
      isModal,
      false,
    );
  }
};

export const prodQuantityForCatering = (event, pdpCateringItemQuantityLimit, setProdQuantity) => {
  event.preventDefault();
  let quantity = validateFreeInputField(event, { pdpCateringItemQuantityLimit }).valueToCount;
  quantity !== false && setProdQuantity(quantity);
  const pointer = event.target.selectionStart;
  const element = event.target;
  window.requestAnimationFrame(() => {
    element.selectionStart = pointer;
    element.selectionEnd = pointer;
  });
};

export const setPDPDataHandler = setPDPDataHandlerObj => {
  const {
    productDetails,
    currentItemObject,
    prodURL,
    product_name,
    pdpDataForUpdateFoodLine,
    cartData,
    prodName,
    prodItems,
    pdpPromoPage,
    setPdpData,
    userOrderStateDispatch,
    setMakeItAComboData,
    setRecommendationData,
    setAddOnRecommendedData,
    setCurrentPDPProduct,
    setProdQuantity,
    setRuleName,
  } = setPDPDataHandlerObj;
  const { UPSELL, CROSSELL, PDP_ITEM_CUSTOM_TYPE, SET_PDP_BUTTON_DISABLED, ADDONS } = MENU_PDP_PAGE_CONSTANTS;

  if (
    checkAllTrue([
      isEmptyObject(productDetails),
      isEmptyObject(currentItemObject),
      prodURL === product_name,
      productDetails?.productId === currentItemObject?.id,
    ])
  ) {
    const { additionalProperties } = currentItemObject;
    const addnProps = jsontoObjects(additionalProperties) || {};
    const customizeModgrps = updateModGrps(pdpDataForUpdateFoodLine?.foodLineId, cartData, currentItemObject?.modgrps);
    setPdpData({
      ...currentItemObject,
      additionalProperties: addnProps,
      quantityAddedCart: productDetails?.quantity,
      catalogName: productDetails?.catalogName,
      itemId: productDetails?.productId,
      dname: prodName,
      items: prodItems,
      modgrps: customizeModgrps,
    });
    userOrderStateDispatch({ type: PDP_ITEM_CUSTOM_TYPE, value: currentItemObject?.customizable });
    let comboAndRecommendation = getComboAndRecommendationDataSopac(
      currentItemObject?.recommendationRules,
      UPSELL,
      CROSSELL,
      ADDONS,
    );
    setMakeItAComboData(comboAndRecommendation.combo);
    setRecommendationData(comboAndRecommendation.recommendation);
    setAddOnRecommendedData(comboAndRecommendation?.addOnRecommendedItems);
    setRuleName(comboAndRecommendation?.ruleName);
    setCurrentPDPProduct(currentItemObject);
    userOrderStateDispatch({ type: SET_PDP_BUTTON_DISABLED, value: {} });
    setProdQuantity(getQuantity(pdpPromoPage, currentItemObject?.id, pdpDataForUpdateFoodLine, cartData));
    window.scrollTo(0, 0);
  }
};

export const checkIfProdQtyUpdate = (pdpPayloadData, prodQuantity, pdpDataId, userOrderStateDispatch) => {
  if (getAndCheck(pdpPayloadData.quantity !== prodQuantity, pdpPayloadData?.id === pdpDataId)) {
    let payloadUpdatedQty = updateItemQuantity(pdpPayloadData, prodQuantity);
    userOrderStateDispatch({ type: MENU_PDP_PAGE_CONSTANTS.PDP_PAYLOAD_DATA, value: payloadUpdatedQty });
  }
};

export const checkIfItemUpdated = params => {
  const {
    pdpData,
    prodQuantity,
    tenantData,
    PDP_PAYLOAD_DATA,
    userOrderStateDispatch,
    pdpPromoPage,
    storeTimeZone,
    pdpDataForUpdateFoodLine,
    cartData,
  } = params;
  if (checkAllTrue([isEmptyObject(pdpData), isEmptyObject(tenantData)])) {
    resetPayload(
      pdpData,
      prodQuantity,
      tenantData.currencyConversionFactor,
      PDP_PAYLOAD_DATA,
      userOrderStateDispatch,
      pdpPromoPage,
      storeTimeZone,
      pdpDataForUpdateFoodLine,
      cartData,
    );
  }
};

export const getQuantity = (pdpPromoPage, itemId, pdpDataForUpdateFoodLine, cartData) => {
  const promoDetails = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.VIEW_PRODUCT));
  if (pdpPromoPage) {
    return +(promoDetails?.promoParams?.find(it => it?.itemId === itemId)?.quantity ?? 1);
  }
  return getQuanitityFromCartReducer(pdpDataForUpdateFoodLine, cartData);
};
export const getQuanitityFromCartReducer = (pdpDataForUpdateFoodLine, cartData) => {
  let quanitity = 1;
  const foodLineId = pdpDataForUpdateFoodLine?.foodLineId;
  if (foodLineId !== '') {
    let itemMatched = cartData?.foodLines?.find(({ id }) => id === foodLineId);
    quanitity = itemMatched?.quantity;
  }
  return quanitity;
};

export const getNameAndRecommendationType = recommendationRules => {
  const { name = [], recommendationType = '' } = recommendationRules ?? {};
  return {
    ruleName: name[0]?.value || '',
    recommendationType,
  };
};
export const removePromoTag = (pdpItemUpsizeId, userOrderStateDispatch) => {
  const promoDetails = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.VIEW_PRODUCT));
  const promoAvailability = promoDetails?.priceDetails?.find(it => it?.id === pdpItemUpsizeId);
  userOrderStateDispatch({
    type: MENU_PDP_PAGE_CONSTANTS.SET_PDP_PROMO_MODE,
    value: { pdpPromoPage: !!promoAvailability?.id },
  });
};
